import React from "react";
import { compose } from "recompose"
import { connect } from "react-redux"
import { updateAnswers } from "store/actions"
import Auth from "auth"
import IntroPage from "./intro"
import ThankyouPage from "./thankyou"
import ExpiredPage from "./expiredPage"

//Config wording ===== 
import wordingSeriesSubject from "configs/wordingSeriesSubject.jsx"
import wordingQuestion from "configs/wordingQuestion.jsx"
//Component ==========
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Checkbox from "@material-ui/core/Checkbox";
import CardContent from '@material-ui/core/CardContent';

import FormControlLabel from '@material-ui/core/FormControlLabel';

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Autocomplete from "components/Autocomplete/Select.jsx";

import UrlServer from "UrlServer"
import { APIGet, APIPost } from "APIAxios"
// import { APIGet,APIPost } from "APIRequest"
// import APIAxios from "APIAxios"
import * as Alert from "alertService"
import ConfigHost from "ConfigHost"


import Check from "@material-ui/icons/Check";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

//Question Component ==========   
import QRadio from "./QuestionComponents/QRadio";
import QSlider from "./QuestionComponents/QSlider";
import SubjectLabel from "./QuestionComponents/SubjectLabel";
import QInput from "./QuestionComponents/QInput";
import QButtonPoint from "./QuestionComponents/QButtonPoint";

import FadeIn from 'react-fade-in';
import Button from "components/CustomButtons/Button.jsx"
import NavigateNextIcon from "@material-ui/icons/NavigateNext"
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore"

import withStyles from "@material-ui/core/styles/withStyles";

import LogoImage from "assets/img/nissan_logo.png";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import bgImage_question from "assets/img/bg_q.png";
import Scroll from "react-scroll"
var scroll = Scroll.animateScroll;
var browserInfo = require('browser-info')
var publicIp = require('public-ip');

const wording = {
  text_btn: {
    th: "ต่อไป",
    en: "Next Page",
  },
  text_btn_b: {
    th: "ย้อนกลับ",
    en: "Back Page",
  },
  title_alert: {
    // th:"แจ้งเตือน",
    // en:"Warning",
    th: "",
    en: "",
  },
  button_name_alert: {
    th: "ทราบแล้ว",
    en: "OK",
  },
  comment_alert: {
    th: "โปรดระบุ",
    en: "please specify",
  }
}

class SurveyPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isAdmin: false,
      isSup: false,
      isQC: false,

      //------------
      customer_fullname: null,
      user_login_fullname: null,
      close_case_date: null,
      //------------

      qestion_id: null,
      expired: false,
      branchName: "",
      language: this.props.match.params.lng,
      isReady: false,
      // step:-1, 
      step: 0,
      //-1 ==> loading
      //0 ==> intro
      //1 ==> section 1
      //2 ==> section 2
      //3 ==> section 3
      //4 ==> thank you 
      allAnswers: {},
      customerID: this.props.match.params.cus,
      customerData: {},
      percentDoing: 0,

      last_active_by_browser: null,
      last_active_public_ip: null,
      election_list: [],
      election_selected: [],
    }
  }
  componentDidMount() {
    Alert.Loading(true)
    if (this.state.language == "admin") {
      this.setState({
        isAdmin: true,
        language: "th"
      }, () => { this.initData() })
    }
    else if (this.state.language == "sup") {
      this.setState({
        isSup: true,
        language: "th"
      }, () => { this.initData() })
    }
    else if (this.state.language == "qc") {
      this.setState({
        isQC: true,
        language: "th"
      }, () => { this.initData() })
    }
    else {
      this.initData()
    }

  }
  initData = () => {
    this.getDataCustomer(() => {
      Alert.LoadingClose()
      this.setState({ isReady: true }, () => {
        this.detectTool()
      })
      // })
    })
  }
  detectTool = () => {
    var _browserInfo = browserInfo()
    if (_browserInfo) {
      _browserInfo = JSON.stringify(_browserInfo)
    }
    this.setState({
      last_active_by_browser: _browserInfo,
    }, () => {
      (async () => {
        var ip4 = await publicIp.v4()
        this.setState({
          last_active_public_ip: ip4,
        })
      })();
    })
  }
  // getDataQuestionByCustomer = (callback) => {
  //   APIPost(UrlServer.URL_POST_QUESTION_GET, { cus_id: this.state.customerID }, ({ datas }) => {
  //     if (datas) {
  //       this.setState({
  //         allAnswers: JSON.parse(datas.answers_obj),
  //         step: (this.state.isQC || this.state.isSup) ? 0 : datas.pass_path
  //       }, () => {
  //         this.props.updateAnswers(this.state.allAnswers)
  //         if (callback) callback()
  //         else Alert.LoadingClose()
  //       })
  //     } else {
  //       this.saveAndChangePage(0, false, () => {
  //         window.location.reload();
  //       })
  //       // window.location.reload();
  //     }
  //   })
  // }
  getDataCustomer = (callback) => {
    APIGet(UrlServer.URL_GET_LEADUSE + "/" + this.state.customerID, (datas) => {
      if (datas.expired == true) {
        this.setState({
          expired: true,
        })
        Alert.LoadingClose()
        return
      }
      if (datas.datas[0].election_selected != null) {
        this.setState({
          isReady: true,
          step: 1,
        })
        Alert.LoadingClose()
        return
      }

      var data_cus = datas.datas[0].user_data_id
      var customer_fullname = data_cus.first_name + " " + data_cus.last_name

      this.setState({
        step: 0,
        customerData: datas.datas[0],
        customer_fullname: customer_fullname,
        election_list: datas.election_list
      }, () => {
        if (callback) callback()
        else Alert.LoadingClose()
      })
    })
  }
  // getBranchName = (code, callback) => {
  //   APIPost(UrlServer.URL_POST_BRANCH_CODE_TO_NAME, { code: code }, ({ data }) => {
  //     this.setState({
  //       branchName: data == "" ? '"ไม่พบสาขาในระบบ"' : data
  //     }, () => {
  //       if (callback) callback()
  //       else Alert.LoadingClose()
  //     })
  //   })
  // }
  handleChangeSelect = name => value => {
    this.setState({
      [name]: value,
    });
  }

  saveAndChangePage = () => {
    this.checkAnswerRequire(() => {
      Alert.Loading(true)
      var election_selected = []
      this.state.election_list.map((row) => {
        if (this.state.election_selected.indexOf(row._id) != -1) {
          election_selected.push({
            first_name: row.user_data_id.first_name,
            last_name: row.user_data_id.last_name,
          })
        }
      })
      var data_for_send = {
        id: this.state.customerData._id,
        election_selected: election_selected
      }
      data_for_send.pass_path = this.state.step
      APIPost(UrlServer.URL_POST_QUESTION_UPSERT, data_for_send, ({ datas }) => {
        this.setState({ step: 1 }, () => {
          Alert.LoadingClose()
        })
      })
    })
  }

  checkAnswerRequire = (callback) => {
    if (this.state.election_selected.length < 6) {
      Alert.WarningTitleCallback("แจ้งเตือน", "ยังไม่ครบ 6 รายชื่อ", "รับทราบ");
      return
    }
    callback()
  }
  handleChangeAnswer = (index, row, checked) => {
    console.log(index, row, checked)
    if (checked) {
      var election_selected = this.state.election_selected
      if (election_selected.length < 6) {
        election_selected.push(row._id)
        this.setState({
          election_selected: election_selected
        }, () => {
          if (election_selected.length == 6) {
            Alert.SuccessCallback("ครบ 6 รายชื่อแล้ว ท่านสามารถกดยืนยันการเลือกตั้ง หรือถ้าท่านต้องการเปลี่ยนแปลงสามารถกดที่รายชื่อเดิมเพื่อยกเลิกรายชื่อและทำการเลือกชื่อใหม่");
          }
        })
      }

    } else {
      var index = this.state.election_selected.indexOf(row._id)
      var election_selected = this.state.election_selected
      election_selected.splice(index, 1)
      this.setState({
        election_selected: election_selected
      }, () => {

      })
    }
  }
  checkSelected = (id) => {
    if (this.state.election_selected.indexOf(id) != -1) {
      return true
    }
    return false
  }
  randerList = (data) => {
    return data.map((row, index) => {
      var checked = this.checkSelected(row._id)
      return <div>
        <FormControlLabel
          disabled={false}
          control={
            <Checkbox
              checked={checked}
              onClick={(e) => this.handleChangeAnswer(index, row, e.target.checked)}
              checkedIcon={
                <Check className={this.props.classes.checkedIcon} />
              }
              icon={<Check className={this.props.classes.uncheckedIcon} />}
              classes={{
                checked: this.props.classes.checked
              }}
            />
          }
          classes={{
            label: this.props.classes.label
          }}
          label={<div className={"wp p-r-2 " + (checked ? "txt-c-b2" : "")}>{row.user_data_id.first_name + " " + row.user_data_id.last_name}</div>}
        />
      </div>
    })
  }
  render() {
    const { classes } = this.props;
    return (
      <div>
        -
        <div className="header">
          <div className="header-txt">
            {(this.state.step == 0) ?
              <b>My Vote : เลือกแล้ว {this.state.election_selected.length}/ 6 ท่าน</b>
              :
              <b>My Vote </b>
            }

          </div>
        </div>
        {
          (!this.state.isReady) ? "" :
            <div>
              {
                (this.state.step === 0) ?
                  <FadeIn>
                    <IntroPage
                      isScriptAgent={this.state.isAdmin || this.state.isQC || this.state.isSup}
                      customer_fullname={this.state.customer_fullname}
                      user_login_fullname={this.state.user_login_fullname}
                      close_case_date={this.state.close_case_date}
                      language={this.state.language}
                      customerData={this.state.customerData}
                      isFinish={
                        (
                          (this.state.allAnswers &&
                            this.state.allAnswers.sc1 &&
                            this.state.allAnswers.sc1.q1 &&
                            this.state.allAnswers.sc1.q1.value == "1")
                          ||
                          (this.state.allAnswers.sc1 == undefined)
                        ) ? false : true
                      }
                      saveAndChangePage={this.saveAndChangePage}
                    >
                      <Card className="card-bg-90">
                        <CardContent>
                          <h4><b>รายชื่อดังนี้</b> </h4>
                          {this.randerList(this.state.election_list)}
                        </CardContent>
                      </Card>
                    </IntroPage>
                  </FadeIn>
                  : ""
              }
              {
                (this.state.step === 1) ?
                  (<div className="intro-card-customer-3"><FadeIn>
                    <GridContainer justify="center">
                      <GridItem xs={11} sm={11} md={10}>
                        <ThankyouPage
                          isScriptAgent={this.state.isAdmin || this.state.isQC || this.state.isSup}
                          language={this.state.language}
                          customerData={this.state.customerData}
                        />
                      </GridItem>
                    </GridContainer>
                  </FadeIn></div>) : ""
              }
            </div>
        }
        {
          (this.state.expired) ?
            <ExpiredPage />
            : ""
        }
        <div className="footer">
          <div className="footer-txt">
            <i>@2021</i>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ answers }) {
  return {
    answers: answers
  }
}
export default compose(
  withStyles(loginPageStyle),
  connect(
    mapStateToProps,
    { updateAnswers }
  )
)(SurveyPage)